import React from 'react';
import './ScrollToTopButton.scss';
import arrowUpIcon from 'assets/images/icons/users/arrow-up.svg';

export const ScrollToTopButton: React.FC = () => {
    const handleClick = () => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    };

    return (
        <button
            type="button"
            className="scroll-to-top-button"
            onClick={handleClick}
            aria-label="Remonter en haut de la page"
        >
            <img src={arrowUpIcon} alt="" aria-hidden="true" />
            <span>Remonter en haut de la page</span>
        </button>
    );
};
